import { ActionTypes } from 'src/constants.js'

export const bootApp = () => ({
  type: ActionTypes.BOOT_APP,
})

export const appBooted = () => ({
  type: ActionTypes.APP_BOOTED,
})
